import { refreshToken } from "@/services/api/helpers";
import cookiesService from "@/services/cookiesService";
import { getTokenExpires } from "@/services/tokenService";
import { apiService } from "./api/apiService";

const cookiesServiceInstance = cookiesService.getService();
export const logout = () => {
  cookiesServiceInstance.clearToken();
};
export const checkAuth = async () => {
  const token = cookiesServiceInstance.getAccessToken();
  if (!token) return false;

  const tokenExpires = getTokenExpires(token);
  const currentTime = new Date().getTime() / 1000;
  if (tokenExpires < currentTime + 60) {
    try {
      await refreshToken(false);
      return true;
    } catch (e) {
      return false;
    }
  }
  return true;
};

export const getUserData = async () => {
  try {
    const data = await apiService.get("/common/user_info/");
    return data?.user_info;
  } catch (e) {}
};

export const getCities = async () => {
  try {
    const res = await apiService.get("/common/cities/read/");
    return res?.data;
  } catch (e) {}
};

export const chooseCity = async (city_id) => {
  try {
    const data = await apiService.post("/common/cities/choose/", { city_id });
    return data;
  } catch (e) {}
};
